import Input from "../../../../Core/Fields/Floating/Input"

const Tab2 = ({ vendor_address, shippingaddres }) => {
  return (
    <div
      className="row  m-0"
      style={{ padding: "8px", borderRadius: "5px", height: 'auto' }}
    >
      <div className="col-12">

        <div className="tableLabel">
          <p className="mb-1" style={{ color: "#391F84", fontWeight: '500' }}>
            Supplier Address
          </p>
          <div style={{ width: '99.5%', borderBottom: '1px solid #caced3', marginBottom: '15px' }}></div>
        </div>
      </div>


      <div className="col-md-4 mt-0 mb-2" >
        <Input id="termsandconditions" label="Address 1" readOnly value={vendor_address?.address_line1} style={{ height: '30px' }} />
      </div>

      <div className="col-md-4 mt-0 mb-2" >
        <Input id="termsandconditions" label="Address 2" readOnly value={vendor_address?.address_line2} style={{ height: '30px' }} />
      </div>

      <div className="col-md-4 mt-0 mb-2" >
        <Input id="termsandconditions" label="City" readOnly value={vendor_address?.city} style={{ height: '30px' }} />
      </div>


      <div className="col-md-4 mt-0 mb-2" >
        <Input id="termsandconditions" label="State" readOnly value={vendor_address?.state} style={{ height: '30px' }} />
      </div>


      <div className="col-md-4 mt-0 mb-2" >
        <Input id="termsandconditions" label="Country" readOnly value={vendor_address?.country} style={{ height: '30px' }} />
      </div>

      <div className="col-md-4 mt-0 mb-2" >
        <Input id="termsandconditions" label="Pincode" readOnly value={vendor_address?.pincode} style={{ height: '30px' }} />
      </div>

      <div className="col-md-4 mt-0 mb-2" >
        <Input id="termsandconditions" label="Supplier Contact" readOnly value={vendor_address?.phone} style={{ height: '30px' }} />
      </div>


      <div className="col-12 ">
        <div className="tableLabel">
          <p className="" style={{ color: "#391F84", fontWeight: '500' }}>Shipping Address</p>
          <div style={{ width: '99.5%', borderBottom: '1px solid #caced3', marginBottom: '15px' }}></div>
        </div>
      </div>
      <div className="col-md-4 mt-0 mb-2" >

        <Input id="termsandconditions" label="Shipping Address" readOnly value={shippingaddres} style={{ height: '30px' }} />

      </div>
    </div>
  )
}

export default Tab2